import React from "react";

/**
 * SortIcon - Custom sort icon matching Figma design
 * @param {string} className - Additional CSS classes (use Tailwind text color classes like text-gray-600)
 * @param {boolean} isUpActive - Whether the up arrow is active (should be teal)
 * @param {boolean} isDownActive - Whether the down arrow is active (should be teal)
 */
const SortIcon = ({ 
  className = "text-gray-600", 
  isUpActive = false,
  isDownActive = false
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      className={className}
      style={{ flexShrink: 0 }}
    >
      {/* Down arrow (left side) */}
      <path
        d="M5.5 9.66667L3 12.1667M3 12.1667L0.5 9.66667M3 12.1667V0.5"
        stroke="currentColor"
        className={isDownActive ? "stroke-teal-300" : ""}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Up arrow (right side) */}
      <path
        d="M7.16667 3L9.66667 0.5M9.66667 0.5L12.1667 3M9.66667 0.5V12.1667"
        stroke="currentColor"
        className={isUpActive ? "stroke-teal-300" : ""}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SortIcon;

